import Link from 'next/link';
import React from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { getAssetPath } from 'utils/asset-utils';
import { getBlogUrl, getFrontEndUrl } from 'utils/environment-util';

const SHEF_LOGO_PATH = getAssetPath('/images/shef-logo.svg');

interface IProps {
  className?: string;
}

export const HeaderBar: React.FC<IProps> = ({ className }) => {
  const frontEndUrl = getFrontEndUrl();
  const blogUrl = getBlogUrl();
  return (
    <div
      className={`${className} flex flex-row justify-between border-b border-neutral-800 p-2 text-base font-semibold text-neutral-700 md:px-12`}>
      <div className='flex flex-row gap-9'>
        <NoFollowLink href={frontEndUrl}>
          <img src={SHEF_LOGO_PATH} alt='Shef Logo' className={`h-[24px] w-[60px]`} />
        </NoFollowLink>
        <div className='hidden flex-row gap-5 md:flex'>
          <Link href={`${blogUrl}/our-story`}>Our Story</Link>
          <Link href={`${frontEndUrl}/become-a-shef`}>Become a shef</Link>
        </div>
      </div>
      <div className='flex flex-row gap-4'>
        <NoFollowLink href={`${frontEndUrl}/login`}>Log In</NoFollowLink>
        <NoFollowLink href={`${frontEndUrl}/register`} className='text-neutral-800'>
          Sign Up
        </NoFollowLink>
      </div>
    </div>
  );
};
